__turbopack_context__.v({
  "circleContainer": "ToggleButton-module__z4lMyq__circleContainer",
  "emptyCircle": "ToggleButton-module__z4lMyq__emptyCircle",
  "isElevated": "ToggleButton-module__z4lMyq__isElevated",
  "pill": "ToggleButton-module__z4lMyq__pill",
  "toggleButton": "ToggleButton-module__z4lMyq__toggleButton",
});
